import { Euro } from "lucide-react";
import { money } from "@/lib/format";

// Staff-only financial breakdown: client amount, partner payout, platform profit.
export function PricingBreakdown({ order, compact = false }) {
  const payout = order.partner_payout || {};
  const clientAmount = order.total || 0;
  const payoutAmount = payout.amount;
  const profit = payout.platform_profit != null
    ? payout.platform_profit
    : (payoutAmount != null ? clientAmount - payoutAmount : null);
  return (
    <div className={`rounded-lg border border-slate-200 bg-slate-50 ${compact ? "p-3" : "p-4"} space-y-2`} data-testid="pricing-breakdown">
      <div className="flex items-center gap-1.5 text-slate-400 text-[11px] font-semibold uppercase tracking-wider">
        <Euro size={13} /> Riepilogo finanziario
      </div>
      <div className="flex items-center justify-between text-sm" data-testid="pricing-client-amount">
        <span className="text-slate-500">Importo cliente</span>
        <span className="font-semibold text-slate-900">{money(clientAmount, order.currency)}</span>
      </div>
      <div className="flex items-center justify-between text-sm" data-testid="pricing-partner-payout">
        <span className="text-slate-500">Payout partner</span>
        <span className="font-semibold text-blue-800">{payoutAmount != null ? money(payoutAmount, order.currency) : "—"}</span>
      </div>
      <div className="flex items-center justify-between text-sm pt-1 border-t border-slate-200" data-testid="pricing-platform-profit">
        <span className="text-slate-500">Profitto piattaforma</span>
        <span className="font-semibold text-emerald-700">{profit != null ? money(profit, order.currency) : "—"}</span>
      </div>
    </div>
  );
}
